import React from "react";
import BaseModal from "../BaseModal";
import { GameStatusContext } from "../../../providers/GameStatusProvider";

function TryAgainModal({ open }) {
  const { resetMistakes } = React.useContext(GameStatusContext);

  return (
    <BaseModal
      title={null}
      initiallyOpen={open}
      actionButtonText="Try Again"
      onActionClick={resetMistakes}
      onClose={resetMistakes}
    >
      <div className="grid gap-y-2">
        <p className="text-base font-normal text-center text-foreground">
          Hmm&#8230; not quite.<br/>I&#8217;ll give you another shot.
        </p>
      </div>
    </BaseModal>
  );
}

export default TryAgainModal;
